import { animate, style, transition, trigger } from '@angular/animations';

export const BANNER_SLIDE_IN =
    trigger('bannerSlideIn', [
      transition('void => *', [
        style({ transform: 'translateY(100%)' }),
        animate('.5s 2s ease-out'), // w/ for 2s then run for .5s
      ]),
    ]);
